import { PropAsset } from './PropAsset';

// Tent - Çadır
// TODO: Replace with SVG asset
export class Tent extends PropAsset {
  readonly id = 'tent';
  readonly width = 70;
  readonly height = 65;
  readonly walkable = false;
  readonly collisionRadius = 1.2;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 20 * s, 10 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Tent color based on variant
    const baseColors = ['#8b7355', '#6b5545', '#5a6a5a']; // Brown, dark brown, green
    const frontColors = ['#6b5335', '#4b3525', '#3a4a3a'];
    const baseColor = baseColors[variant || 0] || baseColors[0];
    const frontColor = frontColors[variant || 0] || frontColors[0];

    // Tent body - Ana çadır
    ctx.fillStyle = baseColor;
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);  // Top peak
    ctx.lineTo(cx - 22 * s, cy - 2 * s);  // Bottom left
    ctx.lineTo(cx + 22 * s, cy - 2 * s);  // Bottom right
    ctx.closePath();
    ctx.fill();

    // Front flap - Ön kanat
    ctx.fillStyle = frontColor;
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);
    ctx.lineTo(cx - 10 * s, cy - 2 * s);
    ctx.lineTo(cx + 10 * s, cy - 2 * s);
    ctx.closePath();
    ctx.fill();

    // Opening - Giriş
    ctx.fillStyle = '#1a1a1a';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 28 * s);
    ctx.lineTo(cx - 6 * s, cy - 2 * s);
    ctx.lineTo(cx + 6 * s, cy - 2 * s);
    ctx.closePath();
    ctx.fill();

    // Pole top
    ctx.fillStyle = '#4a3628';
    ctx.beginPath();
    ctx.arc(cx, cy - 40 * s, 2 * s, 0, Math.PI * 2);
    ctx.fill();

    // Highlight line
    ctx.strokeStyle = 'rgba(255,255,255,0.2)';
    ctx.lineWidth = 1 * s;
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);
    ctx.lineTo(cx + 18 * s, cy - 10 * s);
    ctx.stroke();
  }
}
